// extracted by mini-css-extract-plugin
module.exports = {"Microlabel":"Microlabel__1vT1A"};